import styled from 'styled-components';

const ContactPersonWrapper = styled.div`
  display: block;
  margin: 0;
`;

export default ContactPersonWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/ContactPersonWrapper.jsx